import { useMemo } from "react";

export const Particles = ({ count = 28 }) => {
  const dots = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: `${(i * 37) % 100}%`,
        size: 1 + ((i * 7) % 3),
        duration: `${9 + ((i * 13) % 12)}s`,
        delay: `${-((i * 11) % 18)}s`,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {dots.map((d, i) => (
        <span
          key={i}
          className="particle"
          style={{ left: d.left, width: d.size, height: d.size, animationDuration: d.duration, animationDelay: d.delay }}
        />
      ))}
    </div>
  );
};
